import getColor from "@insite/mobius/utilities/getColor";
import React from "react";

const CrossIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 28 29.19">
            <defs>
                <style>{`.cls-1{fill:#006AE3};fill-rule:evenodd}`}</style>
            </defs>
            <title>{"Close"}</title>
            <g id="PDP-Page">
                <g id="PDP:-Add-to-Cart-Overlay">
                    <g id="Close">
                        <path
                            id="Shape"
                            d="M14.63 16 2.29 28.77a1.28 1.28 0 0 1-1.9 0 1.54 1.54 0 0 1 0-2.05L12 14.67.42 2.66a1.53 1.53 0 0 1 0-2 1.26 1.26 0 0 1 1.89 0l12.32 12.73a1.49 1.49 0 0 1 .37 1.29 1.51 1.51 0 0 1-.37 1.32Z"
                            className="cls-1"
                        />
                        <path
                            id="Shape-2"
                            d="M13.37 13.22 25.71.42a1.28 1.28 0 0 1 1.9 0 1.56 1.56 0 0 1 0 2.06L16 14.52l11.61 12a1.54 1.54 0 0 1 0 2 1.27 1.27 0 0 1-1.89 0L13.37 15.8a1.48 1.48 0 0 1-.37-1.29 1.52 1.52 0 0 1 .37-1.29Z"
                            className="cls-1"
                            data-name="Shape"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default CrossIcon;
